/**
 * SEO utilities for product images.
 */

/**
 * Generate dynamic alt text for a product image.
 * Formula: [Product Name] [Technical Standard] [Material Grade] - Singhania International
 * Fallback: [Product Name] - Singhania International
 */
export function productAlt(product) {
  if (!product) return 'Singhania International';
  const parts = [product.name];
  if (product.standards) parts.push(product.standards.split(',')[0].trim());
  if (product.grade) parts.push(product.grade);
  else if (product.grades?.length) parts.push(product.grades[0]);
  return parts.join(' ') + ' - Singhania International';
}

/**
 * Optimize a Cloudinary URL with f_auto,q_auto for best format/quality.
 * Passes through non-Cloudinary URLs unchanged.
 */
export function optimizeImg(url) {
  if (!url) return url;
  if (url.includes('res.cloudinary.com') && !url.includes('f_auto')) {
    return url.replace('/upload/', '/upload/f_auto,q_auto/');
  }
  return url;
}
